import SaveButton from "../../../../components/SaveButton";
import TextInput from "../../../../components/TextInput";
import { useState } from "react";
import { toast } from "../../../../components/toastNotification";
import CancelButton from "../../../../components/CancelButton";

export const MassUploadFullView = ({
  data,
  isEdit = false,
  updateRow,
  setShowEdit,
  setShow,
  setDisplayNote,
  isForMassUploadCarrier,
  Cancel,
}) => {
  const [formData, setFormData] = useState(data);
  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = () => {
    if (JSON.stringify(data) === JSON.stringify(formData)) {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
    } else if (
      formData.contactType.trim().toLowerCase() === "e&o" &&
      (formData.contactDestination.trim().toLowerCase() === "nsa" ||
        formData.contactDestination.trim().toLowerCase() === "splc")
    ) {
      toast.fire(
        "Saving Failed",
        "Contact Type should be National or States.",
        "warning"
      );
    } else {
      updateRow({
        ...formData,
        expandRow: false,
      });

      setShowEdit(false);
      setShow(false);
      setDisplayNote(true);
    }
  };

  const isNumericInput = (value: string) => value === "" || /^\d+$/.test(value);

  return (
    <div className="w-full">
      <div className="p-2 space-y-4 border-l-2 border-quinary  rounder-r-none box-shadow mb-2">
        <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 text-xs pb-1">
          {isEdit && (
            <div>
              <div className="flex flex-row p-1 justify-between items-center text-quinary font-bold font-sans text-lg pb-1">
                <div className="ml-2 font-bold text-primary text-sm">
                  Edit Carrier Mass Upload
                </div>

                <div className="flex justify-between gap-2 mr-2">
                  <SaveButton onClick={handleSubmit} />
                  <CancelButton onClick={Cancel} />
                </div>
              </div>
              <div className="w-full border-b-2 border-secondary"></div>
            </div>
          )}

          <div className="px-1 py-2 text-primary  font-bold text text-xs mx-1">
            Carrier Details
          </div>

          {isEdit && (
            <div className="text-xxs text-secondary italic font-semibold mx-2 mb-0.5">
              <b> Note:</b> All fields with * are required to fill.
            </div>
          )}
          <div className="text-xs grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 items-start gap-x-4 w-full">
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Carrier Name:
                  {isEdit && <span className="text-red-500">*</span>}
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.carrierName}
                  className="font-normal"
                  name="carrierName"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="text-xs font-medium">
                  {formData.carrierName}
                </div>
              )}
            </div>

            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  State:
                  {isEdit && isForMassUploadCarrier && (
                    <span className="text-red-500">*</span>
                  )}
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  value={formData.states}
                  name="states"
                  onChange={(e) => handleChange(e)}
                  disabled={!isForMassUploadCarrier}
                />
              ) : (
                <div className="text-xs font-medium -ml-12 sm:ml-2">
                  {formData.states}
                </div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Alias:
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  name="alias"
                  value={formData.alias}
                  className={`font-normal ${
                    isForMassUploadCarrier ? "opacity-100" : "opacity-50"
                  }`}
                  onChange={(e) => handleChange(e)}
                  disabled={!isForMassUploadCarrier}
                />
              ) : (
                <div className="text-xs font-medium"> {formData.alias}</div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">FEIN:</label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  name="fein"
                  value={formData.fein}
                  className={`font-normal ${
                    isForMassUploadCarrier ? "opacity-100" : "opacity-50"
                  }`}
                  onChange={(e) => handleChange(e)}
                  disabled={!isForMassUploadCarrier}
                />
              ) : (
                <div className="text-xs font-medium"> {formData.fein}</div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">NAIC:</label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.naic}
                  className={`font-normal ${
                    isForMassUploadCarrier ? "opacity-100" : "opacity-50"
                  }`}
                  name="naic"
                  onChange={(e) => handleChange(e)}
                  disabled={!isForMassUploadCarrier}
                />
              ) : (
                <div className="text-xs font-medium">{formData.naic}</div>
              )}
            </div>

            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Address:
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.address}
                  className={`font-normal ${
                    isForMassUploadCarrier ? "opacity-100" : "opacity-50"
                  }`}
                  name="address"
                  onChange={(e) => handleChange(e)}
                  disabled={!isForMassUploadCarrier}
                />
              ) : (
                <div className="text-xs font-medium">{formData.address}</div>
              )}
            </div>
          </div>
          <div className="border-b mt-3"></div>
          <div className="px-1 py-2 text-primary  font-bold text text-xs mx-1 mt-2">
            Contact Information
          </div>
          {isEdit && (
            <div className="text-xxs text-secondary italic font-semibold mx-2 mb-0.5">
              <b>Note: </b> Contact Destination is required if Contact Type,
              Name, Email, Select Type or Phone number has value.
            </div>
          )}
          <div className="text-xs grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 items-start gap-x-4 w-full space-y-1">
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Contact Destination:
                  {isEdit && <span className="text-red-500">*</span>}
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  className="font-normal"
                  name="contactDestination"
                  value={formData.contactDestination}
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="text-xs font-medium">
                  {formData.contactDestination}
                </div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Contact Type:
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  name="contactType"
                  value={formData.contactType}
                  className="font-normal"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              ) : (
                <div className="text-xs font-medium">
                  {formData.contactType}
                </div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Phone Number:
                  {isEdit && <span className="text-red-500">*</span>}
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  value={formData.phoneNumber}
                  className="font-normal"
                  name="phoneNumber"
                  onChange={(e) => {
                    if (isNumericInput(e.target.value)) {
                      handleChange(e);
                    }
                  }}
                />
              ) : (
                <div className="text-xs font-medium">
                  {formData.phoneNumber}
                </div>
              )}
            </div>

            <div className="w-full grid grid-cols-2 items-center">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Name:
                  {isEdit && formData.contactType !== "" && (
                    <span className="text-red-500">*</span>
                  )}
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  value={formData.name}
                  className="font-normal"
                  name="name"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="text-xs font-medium">{formData.name}</div>
              )}
            </div>
          </div>
          <div className="text-xs grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 items-start gap-x-4 w-full my-2">
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Select Type:
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  name="phoneTypeName"
                  value={formData.phoneTypeName}
                  className="font-normal"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="text-xs font-medium">
                  {formData.phoneTypeName}
                </div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  E&O Submission Type:
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  name="carrierEAndOSubmissionType"
                  value={formData.carrierEAndOSubmissionType}
                  className="font-normal"
                  onChange={(e) => handleChange(e)}
                  disabled={formData.contactType.trim().toLowerCase() !== "e&o"}
                />
              ) : (
                <div className="text-xs font-medium">
                  {formData.carrierEAndOSubmissionType}
                </div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  Email:
                  {isEdit &&
                    formData.carrierEAndOSubmissionType.trim().toLowerCase() ===
                      "email" && <span className="text-red-500">*</span>}
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  name="email"
                  value={formData.email}
                  className="font-normal"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="text-xs font-medium"> {formData.email}</div>
              )}
            </div>
            <div className="w-full grid grid-cols-2 items-center mt-1">
              <div className="flex justify-end space-x-1 text-right mr-2">
                <label className="block font-normal text-gray-700">
                  URL:
                  {isEdit &&
                    formData.carrierEAndOSubmissionType.trim().toLowerCase() ===
                      "online" && <span className="text-red-500">*</span>}
                </label>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  name="url"
                  value={formData.url}
                  className="font-normal"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="text-xs font-medium">{formData.url}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
